import { IconButton } from '@mui/material'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { Close, Done } from '@mui/icons-material'
import { useToggle } from '../../generic/hooks/useToggle'
import { apiDelete, apiPut, apiGet } from '../../generic/Api_Functions'

const ProfileUiElementsDialog = ({ profileId, systemDefault, parentPermission }) => {
  const { t_ } = useSmartTranslation()
  const [toggle, changeToogle] = useToggle()

  const sortOptions = {
    default: {
      field: 'name',
      direction: 1
    }
  }

  // Deleting logic is different with UI elements permissions so it calls a different method
  const handleClick = async (row, field) => {
    if (row.assigned) {
      await apiDelete('profile/' + profileId + '/uiElementPermission/' + row.id)
    } else {
      await apiPut('profile/' + profileId + '/permission/' + row.id)
    }
    changeToogle()
  }

  const getTableButton = (row, field) => {
    return (
      <IconButton disabled={systemDefault || !row.editable} onClick={() => handleClick(row, field)}>
        {row[field] ? <Done color='primary' /> : <Close color='error' />}
      </IconButton>
    )
  }

  const columns = [
    {
      name: t_('Name'),
      field: 'name'
    },
    {
      name: t_('Assigned'),
      field: 'assigned',
      render: row => getTableButton(row, 'assigned')
    }
  ]

  const dataFetch = async (pagination) => {
    const uiELementPermissions = await apiGet('profile/' + profileId + '/uiElementsPermissions/' + parentPermission.id, pagination)
    return uiELementPermissions
  }

  return (
    <>
      <SmartMateriaUITable
        title={t_('UI elements') + ' - ' + parentPermission.name}
        columns={columns}
        dataFetch={dataFetch}
        pageable
        forceLoad={toggle}
        resetPage={toggle}
        sortOptions={sortOptions}
        dense
        sticky={false}
      />
    </>
  )
}

export default ProfileUiElementsDialog
